/**
 * CourseyVoyage 繁體中文字串表
 */
import type { Strings } from './types';

export const zhTW: Strings = {
    'app.loading': '載入中...',
    'app.or': '或者',
    'app.appName': 'CourseyVoyage',
    'app.backPressToExit': '再按一次退出應用',

    'nav.dashboard': '儀表板',
    'nav.schedule': '日程',
    'nav.courses': '課程管理',
    'nav.skills': '學習歷程',
    'nav.finance': '財務',
    'nav.settings': '設定',

    'login.welcome': '歡迎回來',
    'login.loggingIn': '登入中...',
    'login.guest': '訪客登入',
    'login.guestConfirmTitle': '訪客登入確認',
    'login.guestConfirmImportant': '重要提醒：',
    'login.guestConfirmNote': '訪客模式的數據在登出後將會清除，如需保留數據請升級為正式帳號。',
    'login.guestConfirmQuestion': '確認要以訪客模式登入嗎？',
    'login.cancel': '取消',
    'login.confirmLogin': '確認登入',
    'login.readyToStart': '準備好開始學習了嗎？',
    'login.joinUs': '加入我們，幫助孩子管理課程，為孩子的未來做準備。',
    'login.googleLogin': '使用 Google 登入',
    'login.failed': '登入失敗',
    'login.webviewWarningTitle': '您正在使用應用程式內建瀏覽器',
    'login.webviewWarningDesc': 'Google 登入無法在內建瀏覽器中正常運作，請使用系統瀏覽器（Chrome、Safari 等）開啟本網站。',
    'login.webviewGoogleDisabled': '在應用程式內建瀏覽器中無法使用 Google 登入，請使用系統瀏覽器開啟本網站。',

    'bubble.welcome': '歡迎使用 CourseyVoyage！',
    'bubble.rememberCourse': '記得完成今天的課程喔！',
    'bubble.wellDone': '做得好！繼續保持！',
    'bubble.howIsLearning': '你今天學習得如何？',
    'bubble.needHelp': '需要幫忙嗎？',
    'bubble.doubleTapToSwitch': '連點可以切換兒童',
    /* 單一兒童時給家長看的操作提示 */
    'bubble.parentTip1': '點擊頭像可查看操作提示',
    'bubble.parentTip2': '在設定中可管理兒童與課程',
    'bubble.parentTip3': '可在儀表板查看學習概況',
    'bubble.parentTip4': '點設定可新增兒童或課程',
    'bubble.parentTip5': '在課程管理中新增孩子的課程',

    'welcome.noChildMessage': '尚未新增孩子，請先新增孩子資料以開始使用課程管理。',

    'child.all': '全部',
    'child.yearsOld': '歲',
    'child.edit': '編輯',
    'child.delete': '刪除',
    'child.addChild': '＋ 新增孩子',

    'settings.title': '設定',
    'settings.childManagement': '孩子管理',
    'settings.childManagementDesc': '點選孩子頭像或名字可切換目前檢視的孩子',
    'settings.notifications': '通知設定',
    'settings.notifLessonLow': '堂數即將到期',
    'settings.notifLessonLowDesc': '剩餘堂數低於閾值時通知',
    'settings.notifPaymentDue': '繳費到期提醒',
    'settings.notifPaymentDueDesc': '到期前 7 天、3 天通知',
    'settings.notifDailyReminder': '今日課程提醒',
    'settings.notifDailyReminderDesc': '每天有課前 1 小時提醒',
    'settings.thresholdTitle': '提醒條件設定',
    'settings.thresholdDesc': '設定課程剩餘堂數過低，以及課程接近結束日期時，要在畫面上顯示提醒的條件。',
    'settings.thresholdDefault': '剩餘堂數低於',
    'settings.thresholdUnit': '堂時提醒',
    'settings.expiryAlertDays': '課程結束前',
    'settings.expiryAlertDaysUnit': '天開始提醒',
    'settings.account': '帳戶',
    'settings.logout': '登出',
    'settings.logoutDesc': '登出您的帳戶並返回登入頁面',
    'settings.upgradeTitle': '升級為正式帳號',
    'settings.upgradeDesc': '升級為正式帳號可享受數據備份、跨設備同步等。升級後您的所有數據將會保留。',
    'settings.upgradeWithGoogle': '使用 Google 帳戶升級',
    'settings.upgrading': '升級中...',
    'settings.upgradeSuccess': '升級為正式帳號成功！您現在可以使用 Google 帳號登入。',
    'settings.anonymousLogoutTitle': '登出確認',
    'settings.anonymousLogoutImportant': '重要提醒：',
    'settings.anonymousLogoutWarning': '您目前使用的是訪客模式，登出後所有數據將會清除。',
    'settings.anonymousLogoutConfirm': '確認要登出嗎？',
    'settings.confirmLogout': '確認登出',
    'settings.aboutTitle': '關於 CourseyVoyage',
    'settings.aboutVersion': '版本 {version}',
    'settings.aboutDesc': '幫助家長輕鬆管理孩子的所有課程進度、堂數與繳費狀態。',
    'settings.language': '語言',
    'settings.languageDesc': '選擇介面顯示語言',
    'settings.exportTitle': '資料匯出',
    'settings.exportDesc': '匯出指定時間區間內的所有課程資料為 Excel 檔案。',
    'settings.exportDateRange': '時間區間',
    'settings.exportButton': '匯出',
    'settings.exporting': '匯出中...',
    'settings.exportSuccess': '匯出完成',
    'settings.exportEmpty': '此區間內沒有課程資料',
    'settings.exportError': '匯出失敗，請稍後再試',
    'export.reportTitle': '課程資料匯出',
    'export.dateRangeLabel': '匯出區間',
    'export.generated': '匯出時間',
    'export.noData': '此區間內沒有課程資料。',
    'export.date': '日期',
    'export.amount': '金額',
    'export.note': '備註',
    'export.recordType': '類型',
    'export.sheetCourses': '課程',
    'export.sheetPayments': '繳費紀錄',
    'export.sheetRecords': '上課紀錄',
    'export.colChild': '孩子',
    'export.colCourseName': '課程名稱',
    'export.colInstitution': '機構',
    'export.colTeacher': '老師',
    'export.colStartDate': '開始日期',
    'export.colEndDate': '結束日期',
    'export.colTotalLessons': '總堂數',
    'export.colUsedLessons': '已用堂數',
    'export.colStatus': '狀態',
    'export.colCourseFee': '課程費用',
    'export.sectionPayments': '區間內繳費',
    'export.sectionRecords': '區間內上課紀錄',
    'export.colRemainingLessons': '剩餘堂數',
    'export.colTotalPaid': '已繳總額',
    'export.colTotalRefunded': '退款總額',
    'export.colNetPaid': '淨繳費',
    'export.colRemainingPayment': '待繳金額',
    'export.paymentStatusPaid': '已繳完',
    'export.paymentStatusUnpaid': '待繳費',
    'export.colEffectiveEndDate': '有效結束日',
    'export.sectionAllPayments': '繳費紀錄',
    'export.sectionAllRefunds': '退款紀錄',
    'export.scheduleWeekPrefix': '週',
    'export.recordCompleted': '完成上課',
    'export.recordLeave': '請假',
    'export.recordCancelled': '停課',
    'export.recordMakeup': '補課',
    'export.colSchedule': '上課日',
    'export.colMonth': '月份',

    'modal.addChild': '新增孩子',
    'modal.editChild': '編輯孩子',
    'modal.deleteChild': '刪除孩子',
    'modal.childName': '姓名',
    'modal.childNamePlaceholder': '請輸入孩子姓名',
    'modal.gender': '性別',
    'modal.genderMale': '男',
    'modal.genderFemale': '女',
    'modal.birthdate': '生日',
    'modal.avatar': '頭像',
    'modal.cancel': '取消',
    'modal.skip': '稍後再說',
    'modal.save': '儲存',
    'modal.saving': '儲存中...',
    'modal.add': '新增',
    'modal.delete': '刪除',
    'modal.deleting': '刪除中...',
    'modal.confirmDeleteChild': '確定要刪除「{name}」嗎？此操作無法復原。',
    'modal.confirmDeleteChildNote': '此操作無法復原',
    'modal.duplicateChildName': '已有相同名稱的孩子',
    'modal.addFailed': '新增失敗，請重試',
    'modal.updateFailed': '更新失敗，請重試',
    'modal.deleteFailed': '刪除失敗，請重試',

    'dashboard.title': '儀表板',
    'dashboard.activeCourses': '進行中課程',
    'dashboard.todayCourses': '今日課程',
    'dashboard.pendingPayments': '待繳費',
    'dashboard.lessonLowAlert': '堂數即將到期',
    'dashboard.pendingPaymentsAlert': '有 {count} 筆待繳費',
    'dashboard.checkFinance': '請到財務頁面確認',
    'dashboard.noCoursesToday': '今天沒有課程，好好休息吧！',
    'dashboard.courseList': '課程列表',
    'dashboard.checkIn': '完成上課',
    'dashboard.checkInSuccess': '✅ 上課記錄已更新！',
    'dashboard.remaining': '剩餘',
    'dashboard.remainingToPay': '剩餘應繳',
    'dashboard.lessons': '堂',
    'dashboard.payButton': '繳費',

    'courses.title': '課程管理',
    'courses.filterAll': '全部',
    'courses.filterActive': '進行中',
    'courses.filterLow': '即將到期',
    'courses.filterExpired': '待繳費',
    'courses.filterPaid': '已繳費',
    'courses.filterDone': '已完課',
    'courses.filterPaused': '暫停中',
    'courses.sortBy': '排序方式',
    'courses.sortByCreatedAt': '建立時間',
    'courses.sortByStartDate': '開始時間',
    'courses.sortByEndDate': '結束時間',
    'courses.sortByName': '課程名稱',
    'courses.sortByTotalLessons': '總堂數',
    'courses.sortByRemainingLessons': '剩餘堂數',
    'courses.sortByFee': '費用',
    'courses.sortOrderAsc': '正向排序（點擊切換為反向）',
    'courses.sortOrderDesc': '反向排序（點擊切換為正向）',
    'courses.loading': '載入中...',
    'courses.empty': '沒有符合條件的課程',
    'courses.emptyHint': '點擊右上角 ＋ 新增課程',
    'courses.pageInfo': '第 {current} / {total} 頁',
    'courses.addCourse': '新增課程',
    'courses.addChildFirst': '請先新增孩子',
    'courses.addFailed': '新增失敗，請重試',
    'courses.dateRange': '{start} ～ {end}',
    'courses.dateRangeStartOnly': '{start} ～',
    'courses.totalPaid': '總繳費',
    'courses.totalRefunded': '總退款',
    'courses.netPaid': '實際繳費',
    'courses.pleaseFillCourseName': '請填寫課程名稱',
    'courses.pleaseFillStartDate': '請選擇開始日期',
    'courses.courseFeeInvalid': '課程費用不可為負數',
    'courses.pleaseFillCourseFee': '請填寫課程費用',
    'courses.courseName': '課程名稱 *',
    'courses.courseNamePlaceholder': '例：英文會話班',
    'courses.courseType': '課程類型',
    'courses.institution': '機構',
    'courses.institutionPlaceholder': '例：ABC 補習班',
    'courses.teacher': '老師',
    'courses.teacherPlaceholder': '例：王老師',
    'courses.optionalSuffix': '（選填）',
    'courses.weekdays': '上課星期',
    'courses.startTime': '開始時間',
    'courses.endTime': '結束時間',
    'courses.location': '地點',
    'courses.locationPlaceholder': '例：教室名稱或上課地點',
    'courses.startDate': '開始日期',
    'courses.endDate': '結束日期',
    'courses.byLessons': '依總堂數',
    'courses.byEndDate': '依結束日期',
    'courses.courseFee': '課程費用',
    'courses.courseFeePlaceholder': '例：9000（NT$）',
    'courses.paymentMode': '繳費方式',
    'courses.paymentFull': '全繳',
    'courses.paymentMonthly': '月繳',
    'courses.paymentPerClass': '堂繳',
    'courses.monthlyFee': '每月應繳金額',
    'courses.perClassFee': '每堂金額',
    'courses.perClassFeePlaceholder': '例：500',
    'courses.monthlyFeePlaceholder': '例：3000',
    'courses.dueDayOfMonth': '每月幾號前提醒繳費',
    'courses.dueByDay': '{day} 號前繳費',
    'courses.dueDayOfMonthPlaceholder': '例：5（每月5號前）',
    'courses.reminderDaysBefore': '到期前幾天列入提醒',
    'courses.reminderDaysBeforePlaceholder': '例：3',
    'courses.pleaseFillDueDayOfMonth': '請填寫每月幾號前繳費',
    'courses.pleaseFillReminderDaysBefore': '請填寫到期前幾天列入提醒',
    'courses.totalLessons': '總堂數',
    'courses.pleaseFillTotalLessons': '請填寫總堂數',
    'courses.pleaseFillEndDate': '請選擇結束日期',
    'courses.pleaseSelectWeekdays': '請先選擇星期並新增課堂',
    'courses.selectWeekday': '選擇星期',
    'courses.addSlot': '新增課堂',
    'courses.scheduleOverlap': '同一天不可有時間重疊的課堂',
    'courses.noLessonsInRange': '該日期區間內沒有符合上課星期的堂數',
    'courses.totalLessonsLessThanUsed': '計算出的總堂數（{computed}）不可少於目前已上堂數（{used}），請調整日期或上課星期',
    'courses.endTimeMustAfterStart': '結束時間不可早於開始時間',
    'courses.alertThreshold': '剩餘堂數提醒（低於此數時警示）',
    'courses.courseColor': '課程顏色',
    'courses.status': '狀態',
    'courses.editCourse': '編輯課程',
    'courses.confirmDeleteCourse': '確定要刪除「{name}」嗎？將完整刪除整期課程（含上課記錄、繳費紀錄等），此操作無法復原。',
    'courses.updateFailed': '更新失敗，請重試',
    'courses.deleteFailed': '刪除失敗，請重試',
    'courses.pauseCourse': '暫停課程',
    'courses.resumeCourse': '恢復課程',
    'courses.copyCourse': '複製',
    'courses.leaveDeductsLesson': '請假時扣堂數',

    'courseType.語言': '語言',
    'courseType.音樂': '音樂',
    'courseType.體育': '體育',
    'courseType.學科': '學科',
    'courseType.才藝': '才藝',
    'courseType.美術': '美術',
    'courseType.其他': '其他',

    'status.active': '進行中',
    'status.low': '即將到期',
    'status.expired': '待繳費',
    'status.paymentPaid': '已繳完',
    'status.paused': '暫停中',
    'status.done': '已完課',

    'detail.back': '返回',
    'detail.edit': '編輯',
    'detail.delete': '刪除',
    'detail.remainingLessons': '剩餘堂數',
    'detail.usedLessons': '已上堂數',
    'detail.totalLessons': '總購買堂數',
    'detail.usedPercent': '已使用 {pct}%',
    'detail.completed': '✅ 完成上課',
    'detail.leave': '✗ 請假',
    'detail.makeup': '🔁 補課',
    'detail.cancelled': '⛔ 停課',
    'detail.courseInfo': '📋 課程資訊',
    'detail.institution': '機構',
    'detail.teacher': '老師',
    'detail.weekdays': '上課日',
    'detail.timeRange': '上課時段',
    'detail.startDate': '開始日期',
    'detail.endDate': '結束日期',
    'detail.location': '地點',
    'detail.leaveDeductsLesson': '請假是否扣堂',
    'detail.leaveDeductsLessonYes': '會扣',
    'detail.leaveDeductsLessonNo': '不扣',
    'detail.courseFee': '課程費用',
    'detail.contact': '聯絡電話',
    'detail.belongsTo': '歸屬',
    'detail.records': '📅 上課記錄',
    'detail.noRecords': '尚無記錄',
    'detail.unrecordedLessons': '未完成紀錄',
    'detail.noUnrecordedLessons': '無未完成紀錄',
    'detail.futureLessons': '未來課程',
    'detail.noFutureLessons': '無未來課程',
    'detail.editFutureLesson': '編輯日期/時間',
    'detail.futureEditOriginal': '原本時段',
    'detail.futureEditDate': '日期',
    'detail.futureEditTime': '時間',
    'detail.futureEditDateMustBeFuture': '請選擇今天之後的日期',
    'detail.futureEditDateExceedsCourseEnd': '日期不可超過課程結束日（{end}）',
    'detail.futureEditTargetHasRecord': '此日期/時間已經有紀錄，請改選其他時段',
    'detail.confirmEditFutureLesson': '確定要將 {fromDate} {fromStart}～{fromEnd} 調整為 {toDate} {toStart}～{toEnd} 嗎？',
    'detail.futureEditFailed': '更新未來課程失敗',
    'detail.prevPage': '上一頁',
    'detail.nextPage': '下一頁',
    'detail.paymentRecords': '💰 繳費記錄',
    'detail.noPaymentRecords': '尚無繳費記錄',
    'detail.addPayment': '＋ 新增繳費',
    'detail.loading': '載入中...',
    'detail.notFound': '找不到此課程',
    'detail.backToCourses': '返回課程列表',
    'detail.recordFailed': '記錄失敗，請重試',
    'detail.makeupDate': '補課日期',
    'detail.makeupTime': '上課時段',
    'detail.makeupNote': '備註（選填）',
    'detail.addMakeup': '新增補課',
    'detail.makeupExceedsTotal': '此課程為依堂數計算，剩餘堂數已用完，無法新增補課。',
    'detail.makeupDateNotFuture': '補課日期不可選未來日期，請選擇今天或之前的日期。',
    'detail.addInsertedLesson': '➕ 新增課堂',
    'detail.insertedLessonDate': '上課日期',
    'detail.insertedLessonTag': '安插補課',
    'detail.editInsertedLesson': '編輯安插課堂備註',
    'detail.removeInsertedLesson': '取消安插',
    'detail.confirmRemoveInserted': '確定要取消此安插課堂嗎？',
    'detail.insertedExceedsTotal': '剩餘堂數不足，無法安插課堂。',
    'detail.insertedDateMustBeFuture': '請選擇明天（含）之後的日期。',
    'detail.insertedDateBeforeStart': '日期不可早於課程開始日。',
    'detail.insertedDateAfterEnd': '日期不可超過課程有效期限。',
    'detail.insertedPausedNotAllowed': '課程暫停中，無法於暫停日（含）之後安插課堂。',
    'detail.insertedSlotConflict': '此日期與時段已有課堂或記錄。',
    'detail.insertedTimeOverlap': '此時段與當日其他課堂時間重疊。',
    'detail.insertedEndTimeBeforeStart': '結束時間不可早於開始時間。',
    'detail.editRecord': '編輯',
    'detail.deleteRecord': '刪除',
    'detail.confirmDeleteRecord': '確定要刪除此記錄嗎？',
    'detail.note': '備註',
    'detail.refundRecords': '退款紀錄',
    'detail.refundDate': '退款日期',
    'detail.addRefund': '＋ 新增退款',
    'detail.editPayment': '編輯繳費',
    'detail.confirmDeletePayment': '確定要刪除此筆繳費記錄嗎？',
    'detail.noRefundRecords': '尚無退款記錄',
    'detail.noRefundableAmount': '無可退款金額',
    'detail.refundExceedsPayments': '退款金額不可超過已繳費總額，最多可退 NT$ {max}',
    'detail.refundMaxHint': '最多可退款 NT$ {max}',

    'payment.add': '新增繳費記錄',
    'payment.date': '繳費日期',
    'payment.amount': '金額 (NT$) *',
    'payment.month': '繳費月份',
    'payment.monthPlaceholder': '例：2025-03',
    'payment.amountPlaceholder': '例：9000',
    'payment.lessons': '購買堂數',
    'payment.lessonsPlaceholder': '例：30',
    'payment.method': '繳費方式',
    'payment.status': '繳費狀態',
    'payment.dueDate': '到期日',
    'payment.note': '備註（選填）',
    'payment.notePlaceholder': '例：第一期費用',
    'payment.perClassAmountHint': '堂繳課程會自動依據堂數試算金額，請依實際狀況進行繳費',
    'payment.receipt': '繳費憑證',
    'payment.receiptSelected': '已選擇：{name}',
    'payment.receiptRemove': '移除',
    'payment.receiptRemoveExisting': '移除憑證',
    'payment.receiptView': '顯示繳費憑證',
    'payment.receiptNone': '無上傳繳費憑證',
    'payment.receiptUploadFailed': '上傳憑證失敗，請重試',
    'payment.receiptAlt': '繳費憑證',
    'payment.receiptAltCurrent': '目前憑證',

    'paymentMethod.現金': '現金',
    'paymentMethod.匯款': '匯款',
    'paymentMethod.信用卡': '信用卡',
    'paymentMethod.LINE Pay': 'LINE Pay',

    'paymentStatus.paid': '已繳費',
    'paymentStatus.pending': '待繳費',
    'paymentStatus.overdue': '已逾期',

    'finance.title': '財務',
    'finance.paid': '✅ 已繳費',
    'finance.pending': '⏳ 待繳費',
    'finance.totalRemainingEstimate': '未繳總額估算',
    'finance.overdue': '🔴 已逾期',
    'finance.categoryChart': '科目支出佔比',
    'finance.monthlyChart': '近 6 個月花費',
    'finance.noItems': '沒有{status}的項目',
    'finance.markPaid': '標記已繳',
    'finance.markPaidSuccess': '✅ 已標記為已繳費！',
    'finance.dueDate': '到期日：',
    'finance.paymentRefundRecords': '繳費／退款記錄',

    'schedule.title': '日程',
    'schedule.dayView': '日',
    'schedule.weekView': '週',
    'schedule.monthView': '月',
    'schedule.week': '週',
    'schedule.monthYear': '{year} 年 {month} 月',
    'schedule.monthPart': '{month} 月',
    'schedule.prevDay': '前一天',
    'schedule.nextDay': '下一天',
    'schedule.prevWeek': '前一週',
    'schedule.nextWeek': '下一週',
    'schedule.goToToday': '今天',
    'schedule.prevMonth': '上一月',
    'schedule.nextMonth': '下一月',
    'schedule.actionCheckIn': '完成上課',
    'schedule.actionLeave': '請假',
    'schedule.actionAbsence': '停課',
    'schedule.confirmRecord': '確定要標記為「{action}」嗎？',

    'weekday.sun': '日',
    'weekday.mon': '一',
    'weekday.tue': '二',
    'weekday.wed': '三',
    'weekday.thu': '四',
    'weekday.fri': '五',
    'weekday.sat': '六',

    'skills.title': '學習歷程',
    'skills.intro': '記錄孩子學過的課程與技能，未來將提供更詳細的分析報告。',
    'skills.activeByType': '進行中課程',
    'skills.overview': '技能概覽',
    'skills.timelineToday': '今日課程時間軸',
    'skills.timelineByDate': '課程日期時間軸',
    'skills.timelineEmpty': '尚無課程日期',
    'skills.preview': '預覽',
    'skills.lessonsAttended': '約 {hours} 堂已上',
    'skills.comingSoon': '完整技能分析功能開發中，敬請期待。',
    'skills.empty': '尚無課程記錄',
    'skills.emptyHint': '新增課程後，學習歷程會自動累積',
    'skills.goToAddCourse': '前往新增課程',
    'skills.timelineRangeLabel': '顯示時間範圍',
    'skills.timelineFrom': '從',
    'skills.timelineTo': '到',
    'skills.timelineReset': '全部',
    'skills.typeLang': '語言能力',
    'skills.typeMusic': '音樂才藝',
    'skills.typeSports': '體能運動',
    'skills.typeAcademic': '學科補強',
    'skills.typeTalent': '才藝表演',
    'skills.typeFineArts': '美術創作',
    'skills.typeOther': '其他',

    'offline.modal.title': '目前離線',
    'offline.modal.description': '您看到的是上次的快取資料，可繼續操作。恢復連線後，變更會自動同步。',
    'offline.modal.confirm': '確認',
    'offline.recovered.title': '已恢復連線',
    'offline.recovered.description': '網路已恢復，建議重新載入以取得最新資料。',
    'offline.recovered.reload': '立即重新載入',
    'offline.recovered.later': '稍後更新',
    'offline.noData.title': '無法載入',
    'offline.noData.description': '目前離線且無快取資料，請連接網路後重新整理。',
    'offline.noData.reload': '重新整理',

    'install.title': '安裝 {name} 到您的設備',
    'install.titleInstalled': '已安裝 {name}',
    'install.howToInstall': '如何安裝 {name}',
    'install.benefits': '安裝後您將享有：',
    'install.benefit1': '更快的載入速度',
    'install.benefit2': '原生應用體驗，全螢幕顯示',
    'install.benefit3': '即時通知，重要更新不遺漏',
    'install.benefit4': '離線使用，即使沒有網路也能使用',
    'install.installing': '正在安裝...',
    'install.installNow': '立即安裝',
    'install.viewInstructions': '查看安裝方法',
    'install.oneClickNote': '點擊上方按鈕即可快速安裝',
    'install.manualNote': '我們將引導您完成安裝步驟',
    'install.dontShowAgain': '不再提示',
    'install.later': '稍後再說',
    'install.useDesktopApp': '建議使用桌面應用',
    'install.useDesktopNote': '您已安裝 CourseyVoyage！',
    'install.continueBrowser': '繼續使用瀏覽器版本',
    'install.desktopHint': '為了獲得最佳體驗，建議使用已安裝的桌面應用程式：',
    'install.back': '返回',
    'install.youAreUsing': '您正在使用：',

    'auth.notLoggedIn': '用戶未登入',
};
